<template>
    <v-card>
        <s-toolbar label="Dar de Baja a Usuarios" dark color="#8e8f91" sync @sync="getData()" search-input @textSearch="filtraData($event)"></s-toolbar>
        <v-container style="padding: 0%;">
            <v-data-table
                height="400px"
                :headers="headers"
                dense
                :items="filteredItems"
                :footer-props="{
                    showCurrentPage: true,
                    showFirstLastPage: true,
                    itemsPerPageOptions: [-1],
                }"
                fixed-header=""
            >
            <template v-slot:[`item.UserSunExpertYSigrehu`]="{ item }">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                    <span>
                        {{ item.UserSunExpertYSigrehu }}
                    </span>
                    <v-tooltip bottom="">
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                x-small
                                :color="item.UsrStatus == 0 ? 'error' : 'success'"
                                @click="toggleUser(item)"
                            >
                                {{ item.UsrStatus == 0 ? "Inactivo" : "Activo" }}
                            </v-btn>
                        </template>
                        <span>{{ item.UsrStatus == 0 ? "Dar de Alta" : "Dar de Baja" }}</span>
                    </v-tooltip>
                </div>
            </template>
            <template v-slot:[`item.UserSAP`]="{ item }">
                <div style="display: flex; align-items: center; justify-content: space-between;">
                    <span>
                        {{ item.UserSAP }}
                    </span>
                    <v-tooltip bottom="">
                        <template v-slot:activator="{ on }">
                            <v-btn
                                v-on="on"
                                :disabled="!item.UserSAP?.trim()? true : false"
                                x-small
                                :color="item.Locked == 'Y' ? 'error' : 'success'"
                                @click="toggleUserSap(item)"
                            >
                                {{ item.Locked == 'Y' ? "Bloqueado" : !item.UserSAP?.trim()? "Sin Usuario SAP": "Desbloqueado" }}
                            </v-btn>
                        </template>
                        <span>{{ item.Locked == 'Y' ? "Desbloquear" : "Bloquear" }}</span>
                    </v-tooltip>
                </div>
            </template>
            </v-data-table>
        </v-container>
    </v-card>
</template>

<script>
import UserSAPService from '../../services/Security/UserSAPService';

export default {
    name: "Unsubscribe",
    data() {
        return {
            headers: [
                { text: "ID", value: "UsrID" },
                { text: "Apellidos y Nombres", value: "NtpFullName" },
                { text: "Documento", value: "PrsDocumentNumber" },
                { text: "Usuario SunExpert y Sigrehu", value: "UserSunExpertYSigrehu", width: 250 },
                { text: "Usuario SAP", value: "UserSAP", width: 280 },
            ],
            items: [],
            searchText: "",
            ipSap: '',
        };
    },
    methods: {
        getData(){
            this.items = [];
            UserSAPService.listUsers(this.$fun.getUserID()).then((response) => {
                this.items = response.data;
            });
        },
        filtraData(event) {
            this.searchText = event ? event.toLowerCase() : "";
        },
        toggleUser(item) {
            item.UsrStatus == 0 ? (item.UsrStatus = 1) : (item.UsrStatus = 0);
            console.log(item);
            this.$fun.alert(
                "¿Esta seguro de " + (item.UsrStatus == 0 ? "Dar de Alta" : "Dar de Baja") + " al usuario " + item.NtpFullName + "?",
                "question"
            ).then((r) => {
                if (r.value) {
                    let uss = { UsrID: item.UsrID, UsrStatus: item.UsrStatus };
                    UserSAPService.toggleUser(uss, this.$fun.getUserID()).then((response) => {
                        if (response.status == 200) {
                            this.$fun.alert("Usuario " + item.NtpFullName + " " + (item.UsrStatus == 0 ? "Dado de Alta" : "Dado de Baja"), "success");
                            this.getData();
                        }
                    });
                }
            })          
        },
        async toggleUserSap(item) {
            this.ipSap = '';

            await UserSAPService.getIP(this.$fun.getUserID()).then((r) => {
                if(r.status == 200){
                console.log(r.data);
                this.ipSap = r.data.ip;
                }
            })

            item.Locked == 'Y' ? (item.Locked = 'N') : (item.Locked = 'Y');
            this.$fun.alert(
                "¿Esta seguro de " + (item.Locked == 'Y' ? "Desbloquear" : "Bloquear") + " al usuario " + item.NtpFullName + "?",
                "question"
            ).then((r) => {
                if(r.value){
                    let uss = { UssUserID: item.UssUserID, Locked: item.Locked, UssUserCode: item.UserSAP, UssIP: this.ipSap };
                    UserSAPService.toggleUserSap(uss, this.$fun.getUserID()).then((response) => {
                        if (response.status == 200) {
                            this.$fun.alert("Usuario " + item.NtpFullName + " " + (item.Locked == 'Y' ? "Desbloqueado" : "Bloqueado"), "success");
                            this.getData();
                        }
                    })
                }
            })
        }
    },
    created() {
        this.getData();
    },
    computed: {
        filteredItems() {
            const filtro = this.searchText?.toLowerCase() || '';
            return this.items.filter(item => {
                return (
                    (item.NtpFullName || '').toLowerCase().includes(filtro) ||
                    (item.PrsDocumentNumber || '').toString().includes(filtro) ||
                    (item.UserSunExpertYSigrehu || '').toLowerCase().includes(filtro) ||
                    (item.UserSAP || '').toLowerCase().includes(filtro)
                );
            });
        }
    }
};
</script>